import * as React from "react";

import {routeConfig} from "../../../../config/language/ja-JP/presentation/route_text";
import {Company} from "../../../../domain/model/company";
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import Breadcrumbs from "../../../common/molecular/breadcrumbs/breadcrumbs";
import Progress from "../../../common/organism/progress";
import {TBreadcrumbItem} from "../../../type/common";
import ClientBillingPlanMain from "./client_billing_plan_main";
import Faq from "../../faq";

interface IProps {
    isInit: boolean;
    isLoading: boolean;
    company: Company | null;
}

const ClientBillingComponent: React.FC<IProps> = (props) => {
    const {isInit, company} = props;

    // 初期化
    if (isInit) {
        return <Progress canAnimation={false}/>;
    }

    const breadcrumbItems: TBreadcrumbItem[] = [
        routeConfig.clientRoot,
        routeConfig.clientMypageCompanyInfo,
        routeConfig.clientBilling,
    ];

    const res: JSX.Element = (
        <React.Fragment>
            <PageWrapper>
                <Breadcrumbs breadcrumbItems={breadcrumbItems}/>

                <Faq title={"料金プランに関して"}
                     text={"ダッシュボードより加入されている料金プランが確認できます。アカウント発行は無料で、成約時の報酬と月額の手数料などが発生します。"}
                     link={
                         "https://branch-saturn-9ef.notion.site/180b91fe393e80c58690c7fc098628f2"
                     }/>

                <ClientBillingPlanMain company={company}/>
            </PageWrapper>
        </React.Fragment>
    );

    return res;
};

export default ClientBillingComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/client/billing/client_billing.tsx